import { GuardedType, isString } from "generic-type-guard";

import { createDescriptorFunctions } from "@de.skhh.modulf/client-core";

import { STAMMDATEN_MODEL_SUFFIX } from "../modules/stammdaten/constants";

import { isUndefined } from "./typeGuardUtils";

export const ProcessOverviewDescriptor = createDescriptorFunctions(
	{
		view: "TaskList"
	} as const,
	{
		model: isString,
		instance: isUndefined,
		processes: isString,
		fachverfahren: isString,
		view: isString
	}
);
export type ProcessOverviewDescriptor = GuardedType<typeof ProcessOverviewDescriptor.isInstance>;

export const CombinedAntragListDescriptor = createDescriptorFunctions(
	{
		model: "Generic_Prozess_WF",
		view: "combinedAntraegeList"
	} as const,
	{}
);
export type CombinedAntragListDescriptor = GuardedType<typeof CombinedAntragListDescriptor.isInstance>;

export const AssignedProcessesDescriptor = createDescriptorFunctions(
	{
		model: "Assigned_Processes_O",
		dashboard: "assignedProcesses"
	} as const,
	{}
);
export type AssignedProcessesDescriptor = GuardedType<typeof AssignedProcessesDescriptor.isInstance>;

export const StammdatenFormDescriptor = createDescriptorFunctions({} as const, {
	instance: isString,
	model: isStammdatenModelName
});

function isStammdatenModelName(value: unknown): value is string {
	return isString(value) && value.endsWith(STAMMDATEN_MODEL_SUFFIX);
}
